import * as React from "react";
import { FormField } from "@/components/molecules/FormField";
import { FormStack } from "@/components/molecules/FormStack";
import { Link } from "@/components/atoms/Link";
import { useBrandingContext } from "@/contexts/BrandingContext";

export const Terms: React.FC<{ text: string }> = ({ text }) => {
  const { brand, termsAndConditionsUrl, privacyPolicyUrl } = useBrandingContext();

  return (
    <FormStack>
      <FormField>
        <div>
          By clicking the ‘{text}’ button, you are creating a {brand} account and you agree to{" "}
          {brand}'s{" "}
          <Link inline target="_blank" to={termsAndConditionsUrl}>
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link inline target="_blank" to={privacyPolicyUrl}>
            Privacy Policy
          </Link>
          .
        </div>
      </FormField>
    </FormStack>
  );
};
